import cashLeftOverType, { CashLeftOverState, ICashLeftOverAction } from "./cashLeftOver.type";

const initialState: CashLeftOverState = {
    resultInit: undefined,
    resultSave: null,
    isLoading: false,
    error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ICashLeftOverAction) => {
    switch (action.type) {
        case cashLeftOverType.INIT_CASH_LEFT_OVER.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case cashLeftOverType.INIT_CASH_LEFT_OVER.SUCCESS:
            return {
                ...state,
                isLoading: false,
                resultInit: action.payload,
            };
        case cashLeftOverType.INIT_CASH_LEFT_OVER.ERROR:
            return {
                ...state,
                isLoading: false,
                resultInit: undefined,
                error: action.error,
            };

        case cashLeftOverType.SAVE_CASH_LEFT_OVER.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case cashLeftOverType.SAVE_CASH_LEFT_OVER.SUCCESS:
            return {
                ...state,
                isLoading: false,
                resultSave: action.payload,
            };
        case cashLeftOverType.SAVE_CASH_LEFT_OVER.CLEAN:
            return {
                ...state,
                isLoading: false,
                resultInit: undefined,
                resultSave: undefined
            };
        case cashLeftOverType.SAVE_CASH_LEFT_OVER.ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
